import { render } from "./CreateRequest6.vue?vue&type=template&id=2006d2f8"
import script from "./CreateRequest6.vue?vue&type=script&lang=js"
export * from "./CreateRequest6.vue?vue&type=script&lang=js"

import "./CreateRequest6.vue?vue&type=style&index=0&id=2006d2f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__